var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.529,
    height: 15.091,
    viewBox: "0 0 12.529 15.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin_2_",
    "data-name": "map-pin (2)",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28802",
    "data-name": "Path 28802",
    d: "M14.529,6.765c0,4.484-5.765,8.327-5.765,8.327S3,11.248,3,6.765a5.765,5.765,0,0,1,11.529,0Z",
    transform: "translate(-3 -1)",
    fill: "none",
    stroke: "#1b2430",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3194",
    "data-name": "Ellipse 3194",
    cx: 1.922,
    cy: 1.922,
    r: 1.922,
    transform: "translate(3.843 3.843)",
    fill: "none",
    stroke: "#1b2430",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.67dff6461ef1c5cd6904a838b2c60ea7.svg";
export { ForwardRef as ReactComponent };